import OfficerFormModalReducer from "../reducers/OfficerFormModalReducer";
import BaseAction from "./BaseAction";

class OfficerFormModalAction extends BaseAction {
  onClose = () => {};

  onSubmit = () => {};

  open = async (onSubmit, data) => {
    this.dispatch({ open: true, ...data });
    this.onSubmit = onSubmit;
  };

  onType = async (searchQuery) => {
    await this.dispatch({ searchQuery: searchQuery });
  };

  setLoadingOfficerTypes = (value) =>
    this.dispatch({ isLoadingOfficerTypes: value });
}

const action = new OfficerFormModalAction(OfficerFormModalReducer);

export default action;
